import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

const featured = movies.filter((m) => m.featured).slice(0, 5);

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % featured.length);
    }, 5200);
    return () => clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setIndex((i) => (i + dir + featured.length) % featured.length);
  };

  return (
    <section className="relative w-full">
      <div className="relative h-[440px] w-full overflow-hidden bg-foreground-950 md:h-[560px]">
        {featured.map((m, i) => (
          <div
            key={m.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
          >
            <img
              src={m.banner}
              alt={`${m.title} 焦点图`}
              title={`${m.title} - 芒果tv 热门推荐`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/45 to-foreground-950/10" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
          </div>
        ))}

        <div className="absolute inset-0 flex items-center">
          <div className="w-full px-4 md:px-8">
            <div className="max-w-xl animate-fade-in">
              <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-fire-line" />
                {featured[index].channel} · 正在热播
              </span>
              <h2 className="mt-4 font-heading text-3xl font-extrabold leading-tight text-background-50 md:text-5xl">
                {featured[index].title}
              </h2>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-background-100/90 md:text-base">
                {featured[index].synopsis}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                {featured[index].tags.map((t) => (
                  <span
                    key={t}
                    className="rounded-full border border-background-50/30 px-3 py-1 text-xs text-background-100"
                  >
                    {t}
                  </span>
                ))}
              </div>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${featured[index].id}`}
                  className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-play-fill text-lg" />
                  立即观看
                </Link>
                <Link
                  to={`/category/${featured[index].channel}`}
                  className="inline-flex items-center gap-2 rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-background-50/10 cursor-pointer whitespace-nowrap"
                >
                  浏览{featured[index].channel}频道
                </Link>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={() => go(-1)}
          aria-label="上一张"
          className="absolute left-3 top-1/2 hidden h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-foreground-950/40 text-background-50 hover:bg-primary-500 md:flex cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-2xl" />
        </button>
        <button
          type="button"
          onClick={() => go(1)}
          aria-label="下一张"
          className="absolute right-3 top-1/2 hidden h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-foreground-950/40 text-background-50 hover:bg-primary-500 md:flex cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-2xl" />
        </button>

        <div className="absolute bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2">
          {featured.map((m, i) => (
            <button
              key={m.id}
              type="button"
              onClick={() => setIndex(i)}
              aria-label={`切换到 ${m.title}`}
              className={`h-2 rounded-full transition-all cursor-pointer ${
                i === index ? "w-7 bg-primary-500" : "w-2 bg-background-50/60"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}